module.exports = __webpack_public_path__ + "img/ultra_1_05.660fe648.jpg";